import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.4004 8.75781L13.4512 17.707L8.63086 22.5439L1.75293 15.667L15.5312 1.88867L22.4004 8.75781ZM4.58203 15.666L8.62793 19.7119L11.3291 17L7.28809 12.959L4.58203 15.666Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H13V20H22V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 18H18V16H22V18Z"}}]};

const CorrectFilled = Vue.extend<IconProps>({
  name: 'CorrectFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'correct-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CorrectFilled;
